<template>
    <!-- <router-view></router-view> -->
    <el-container direction="horizontal" class="app-wrapper" v-if="isShowApp">
        <template>
            <Sidebar
                :isShowMenu="isShowMenu"
                :key="loadTimer"
                ref="sidebar"
                :appState="appState"
                :menuData="menuData"
                :userInfo="userInfo"
                @isShowLeftFunc="isShowLeftFunc"/>
        </template>
        <el-container direction="vertical" class="main-container">
            <Navbar
                   :key="loadTimer2"
                   ref="navbar"
                   :isShowHamburger="isShowHamburger"
                   :appState="appState"
                   :menuData="menuData"
                   :userInfo="userInfo"
                   :isShowLeft="isShowLeft"
                   :activeIndex="activeIndex"
                   @toggleSideBar="handleToggleSideBar"
                   @changeMenu="changeMenu"
                   @isShowLeftFunc="isShowLeftFunc"
                   @sortMenu="sortMenu"/>
            <TagsView ref="tagsView"  :key="loadTimer3" :initPage="initPage"  />
            <div class="app-container" ref="app-container">
                <transition name="fade-transform" mode="out-in">
                    <router-view></router-view>
                </transition>
            </div>
        </el-container>
    </el-container>
</template>

<script>
    import { mapActions, mapGetters } from 'vuex';
    import jsCookies from 'js-cookie';
    import { isEmpty, cloneDeep } from 'lodash';
    import { getCurrentUserInfo, getUserRemindNum, getUserWorkPlantEntry, loginOut } from '@/data-model';
    import * as constants from '@/common/constants';
    import Sidebar from '@/components/Sidebar';
    import Navbar from '@/components/Navbar';
    import TagsView from '@/components/TagsView';
    import { getGlobalConf } from '@/utils/grocer';
    // import routeCustomer from '@/router/modules/route-customer';

    export default {
        components: {
            Sidebar,
            Navbar,
            TagsView
        },
        data () {
            return {
                isShowApp: false,
                initPage: '',
                isShowHamburger: true,
                isShowMenu: false,
                loadTimer: '1',
                loadTimer2: '2',
                loadTimer3: '3',
                menuData: [],
                isShowLeft: window.sessionStorage.getItem('isShowLeft') ? window.sessionStorage.getItem('isShowLeft') : '2',
                activeIndex: '1'
            };
        },
        computed: {
            ...mapGetters([
                'routers',
                'appState',
                'userInfo',
                'menuRemindNum',
                'showLeft',
                'visitedViews',
                'navNumData',
                'workPlantEntry'
            ])
        },
        watch: {
            routers (val) {
                if ((this.userInfo.companyInfo.companyResource.resourceVersion & 4) > 0 && this.userInfo.switchLayoutFlg === 2) { // 新页面默认不显示左侧菜单
                    let currentUserStr = window.sessionStorage.getItem('currentUserInfo');
                    let currentUser = JSON.parse(currentUserStr);
                    let isNewPageInitLoad = window.localStorage.getItem('isNewPageInitLoad' + currentUser.userId);
                    if (isNewPageInitLoad === '1') {
                        let currentPath = this.$route.path;
                        let ROUTER_BASE_PATH = getGlobalConf().routerBasePath;
                        if (currentPath.indexOf(ROUTER_BASE_PATH) !== -1) {
                            currentPath = currentPath.replace(ROUTER_BASE_PATH, '');
                        }
                        let endIdx = currentPath.indexOf('/', currentPath.indexOf('/') + 1);
                        let newTarget = currentPath.substring(0, endIdx);
                        if (newTarget.indexOf('workspace') !== -1) {
                            if (this.userInfo.switchLayoutFlg === 2) {
                                this.menuData = this.workPlantEntry;
                            } else {
                                this.menuData = this.changeMenu(newTarget, currentPath);
                            }
                        } else {
                            this.menuData = this.changeMenu(newTarget, currentPath);
                        }
                        this.loadTimer = new Date().getTime() + '10';
                        // this.activeIndex = '4';
                    }
                    this.isShowMenu = false;
                } else {
                    this.isShowMenu = true;
                    this.menuData = this.routers;
                }
            },
            async menuRemindNum (val) {
                if (val) { // 说明有值
                    let navNumData = {needWorkingTask: val.todoList[0].num, myApprove: val.myApprove[0].num};
                    this[constants.VUEX_ACTIONS_NAV_NUM_DATA](navNumData);
                }
            }
        },
        async created () {
            if (this.userInfo.switchLayoutFlg === 2) {
                this.menuData = [];
                // let currentPath = this.$route.path;
                // if (this.userInfo.portalMode === 0) {
                let currentPath = this.$route.path;
                let ROUTER_BASE_PATH = getGlobalConf().routerBasePath;
                if (currentPath.indexOf(ROUTER_BASE_PATH) !== -1) {
                    currentPath = currentPath.replace(ROUTER_BASE_PATH, '');
                }
                let endIdx = currentPath.indexOf('/', currentPath.indexOf('/') + 1);
                let newTarget = currentPath.substring(0, endIdx);
                if (newTarget === '/process') {
                    this.activeIndex = '2';
                } else if (newTarget === 'document') {
                    this.activeIndex = '3';
                } else if (newTarget === 'office') {
                    this.activeIndex = '4';
                } else if (newTarget === 'operation') {
                    this.activeIndex = '5';
                } else if (newTarget === 'dashboard') {
                    this.activeIndex = '6';
                } else if (newTarget === 'system') {
                    this.activeIndex = '7';
                } else if (newTarget === 'message') {
                    this.activeIndex = '8';
                } else if (newTarget === 'application') {
                    this.activeIndex = '9';
                }
                // if (newTarget.indexOf('workspace' !== -1)) {
                //     this.menuData = this.workPlantEntry;
                // }
                // }
                this.loadTimer = new Date().getTime() + '10';
            } else {
                this.menuData = this.routers;
            }
            // 获取当前登录用户信息
            await this._getCurrentUserInfo();
            // 获取所有的路由和导航数据
            this.isShowApp = true;
            this.isShowHamburger = true;
            // 获取当前用户菜单待办事项的数字角标
            // await this.getUserRemindNum();
            // this.isShowLeft = sessionStorage.getItem('isShowLeft');
            // if (this.isShowLeft === '2') {
            //     this.handleToggleSideBar();
            // }
        },
        methods: {
            ...mapActions([
                constants.VUEX_ACTIONS_ROUTER_GET_ALL,
                constants.VUEX_ACTIONS_SIDEBAR_TOGGLE,
                constants.VUEX_ACTIONS_USER_INFO,
                constants.VUEX_ACTIONS_REMIND_NUM,
                constants.VUEX_ACTIONS_NAV_SHOW_LEFT,
                constants.VUEX_ACTIONS_NAV_NUM_DATA,
                constants.VUEX_ACTIONS_TAGS_VIEW_ADD,
                constants.VUEX_ACTIONS_TAGS_VIEW_DELETE,
                constants.VUEX_ACTIONS_WORK_PLANT_ENTRY,
                constants.VUEX_ACTIONS_LAYOUT_TYPE,
                constants.VUEX_ACTIONS_NAV_SHOW_LEFT
            ]),
            async getUserRemindNum () { // 处理未处理的事项
                let remindNum = await getUserRemindNum();
                this[constants.VUEX_ACTIONS_REMIND_NUM](remindNum);
            },
            async _getCurrentUserInfo () {
                let userInfo = {};
                if (isEmpty(this.userInfo)) {
                    userInfo = await getCurrentUserInfo();
                    this[constants.VUEX_ACTIONS_USER_INFO](userInfo);
                } else {
                    userInfo = this.userInfo;
                }
                if (!userInfo) {
                    await loginOut();
                    window.sessionStorage.removeItem('currentUserType');
                    window.sessionStorage.removeItem('currentUserInfo');
                    window.sessionStorage.removeItem('isNewPageInitLoad');
                    jsCookies.remove('JSESSIONID');
                    this.navLogin();
                }
                this[constants.VUEX_ACTIONS_ROUTER_GET_ALL]();
                setTimeout(() => {
                    if (this.$refs.navbar) {
                        this.$refs.navbar.setUserPic(userInfo.userPic);
                    }
                }, 0);
                let str = JSON.stringify(userInfo);
                window.sessionStorage.setItem('currentUserInfo', str);
                window.localStorage.setItem('currentUserInfo', str);
                if (this.appState) {
                    this.appState.sidebar.opened = true;
                }
                // 工作台处理
                if (userInfo.switchLayoutFlg === 1) {
                    window.sessionStorage.setItem('loadSystem', 2);
                    this[constants.VUEX_ACTIONS_LAYOUT_TYPE]('old');
                    this[constants.VUEX_ACTIONS_NAV_SHOW_LEFT]('show');
                    window.sessionStorage.setItem('isShowLeft', 1);
                } else if (userInfo.switchLayoutFlg === 2) {
                    // 获取用户的工作台导航已经配置好的快捷入口
                    window.sessionStorage.setItem('loadSystem', 1);
                    this[constants.VUEX_ACTIONS_LAYOUT_TYPE]('new');
                    this[constants.VUEX_ACTIONS_NAV_SHOW_LEFT]('hidden');
                    window.sessionStorage.setItem('isShowLeft', 2);
                    this.getUserWorkPlantEntry();
                    this.getUserRemindNum();
                }
            },
            async getUserWorkPlantEntry () {
                let workPlantEntrys = [];
                let workPlantEntry = await getUserWorkPlantEntry({mode: 0});
                if (workPlantEntry && workPlantEntry.data && workPlantEntry.data.length > 0) {
                    let chooseMenu = workPlantEntry.data;
                    let str = window.sessionStorage.getItem('noLeftMenu');
                    let o = JSON.parse(str);
                    let isContainNeedWorkingTask = false;
                    for (let i = 0; i < chooseMenu.length; i++) {
                        let obj = chooseMenu[i];
                        let menu = o.routeWorkbench.find(y => y.id === obj.menuId);
                        if (menu) {
                            menu.dataId = obj.id;
                            workPlantEntrys.push(menu);
                        }
                        if (obj.menuId === 'workspace/needWorkingTask') {
                            isContainNeedWorkingTask = true;
                        }
                    }
                    if (!isContainNeedWorkingTask) {
                        let arr = constants.VUEX_WORK_PLANT_ENTRY;
                        for (let i = 0; i < arr.length; i++) {
                            workPlantEntrys.unshift(arr[i]);
                        }
                    }

                    this[constants.VUEX_ACTIONS_WORK_PLANT_ENTRY](workPlantEntrys);
                    this[constants.VUEX_ACTIONS_NAV_SHOW_LEFT]('hidden');
                    // this.sortMenu();
                } else {
                    let arr = constants.VUEX_WORK_PLANT_ENTRY;
                    for (let i = 0; i < arr.length; i++) {
                        workPlantEntrys.push(arr[i]);
                    }
                }
            },
            async _refreshCurrentUserInfo () { // 刷新当前登录中的用户信息
                let userInfo = await getCurrentUserInfo();
                this[constants.VUEX_ACTIONS_USER_INFO](userInfo);
                setTimeout(() => {
                    if (this.$refs.navbar) {
                        this.$refs.navbar.setUserPic(userInfo.userPic);
                    }
                }, 0);
                let str = JSON.stringify(userInfo);
                window.sessionStorage.setItem('currentUserInfo', str);
            },
            handleToggleSideBar () {
                this[constants.VUEX_ACTIONS_SIDEBAR_TOGGLE]();
            },
            changeMenu (target, initPath, routeName) {
                if (initPath === '/process/approvalDefinitionDesign' || initPath === '/process/processDefinitionDesign' || initPath === '/process/time-config' || initPath === '/process/close-template') {
                    target = '/components';
                }
                if (target === '/workbench') {
                    this.loadTimer = new Date().getTime();
                    this.menuData = this.routers;
                    let path = '/workspace/workbench';
                    this.$router.push(path);
                    if (this.$refs.sidebar) {
                        this.$refs.sidebar.refMenu(this.routers, path);
                    }
                } else {
                    if (target === '/workspace' && this.appState.sidebar.opened) {
                        this.handleToggleSideBar();
                    } else {
                        this.isShowMenu = true;
                    }
                    if (target === '/components') { // 此处设计中心的url的地址和组建的地址不一样所以f5刷新的时候浏览器地址栏的地址无法匹配到路由的地址，故专门做个处理
                        target = '/application';
                    }
                    let menuData = this.setNewMenu2(target);
                    if (target === '/workspace' && this.menuData && this.menuData.length > 0) { // 给工作台左边菜单进行排序处理
                        menuData = menuData.sort(this.compareArr('leftSortOrder'));
                    }
                    if (menuData.length > 0) {
                        setTimeout(() => {
                            if (this.$refs.sidebar) {
                                if (target === '/process') {
                                    let toDefaultProcess = window.sessionStorage.getItem('toDefaultProcess');
                                    if (toDefaultProcess) {
                                        window.sessionStorage.removeItem('toDefaultProcess');
                                        // 跳转到我的流程，我发起的
                                        initPath = '/process/myProcessStartedBy';
                                        routeName = 'myProcessStartedBy';
                                    }
                                    this.$refs.sidebar.refMenu(menuData, initPath, routeName);
                                }
                                this.$refs.sidebar.refMenu(menuData, initPath, routeName);
                                if (target === '/process') {
                                    this.$refs.sidebar.openProcessAllMenu();
                                }
                            }
                        }, 0);
                    }
                    return menuData;
                }
            },
            setNewMenu2 (target) {
                let parentMap = new Map();
                let designMenus = [];
                let menuData = [];
                let ROUTER_BASE_PATH = getGlobalConf().routerBasePath;
                if (target === '/business') {
                    if (this.appState.sidebar.opened === true) {
                        this.handleToggleSideBar();
                    }
                    this.isShowHamburger = false;
                } else {
                    if (this.appState.sidebar.opened === false) {
                        this.handleToggleSideBar();
                    }
                    this.isShowHamburger = true;
                }
                let leftMenuMap = new Map();
                if (this.menuData && this.menuData.length > 0) {
                    let index = 0;
                    this.menuData.forEach(menu => {
                        leftMenuMap.set(menu.id, index);
                        index++;
                    });
                }
                this.routers.forEach(menu => {
                    if (menu.children) {
                        menu.children.forEach(child => {
                            let childMenu = cloneDeep(child);
                            childMenu.children = [];
                            childMenu.leftSortOrder = 0;
                            if (leftMenuMap.has(childMenu.id)) {
                                childMenu.leftSortOrder = leftMenuMap.get(childMenu.id);
                            }
                            if (menu.path === (ROUTER_BASE_PATH + target) || target === '/application') { // 设计中心也可以进这段逻辑
                                parentMap.set(childMenu.id, childMenu);
                                if ((target !== '/application' && child.isDesign && !child.isIgnore)) {
                                    return true;
                                }
                                if (target === '/application' && childMenu.hasOwnProperty('isTitle') && !child.isTitle) {
                                    return true;
                                }
                                if (child.hasOwnProperty('isDesign') && child.isDesign && (!child.hasOwnProperty('pId') || child.isIgnore)) {
                                    designMenus.push(childMenu);
                                }
                                if (childMenu.hasOwnProperty('isNewMenu')) {
                                    childMenu.isShow = childMenu.isNewMenu;
                                }
                                if (child.id && child.id.indexOf('workspace/') !== -1) {
                                    childMenu.isShow = true;
                                }
                                if (childMenu.hasOwnProperty('isTitle') && child.isTitle) {
                                    childMenu.isShow = true;
                                }
                                if (child.isIgnore && target === '/application') {
                                    if (parentMap.has(child.pId2)) {
                                        let subChildMenu = cloneDeep(child);
                                        subChildMenu.isShow = true;
                                        parentMap.get(child.pId2).children.push(subChildMenu);
                                    } else {
                                        menuData.push(childMenu);
                                    }
                                } else if (target === '/operation' && menu.path === '/operation') {
                                    if (childMenu.hasOwnProperty('pId') && parentMap.has(child.pId)) {
                                        let subChildMenu = cloneDeep(child);
                                        subChildMenu.isShow = true;
                                        parentMap.get(child.pId).children.push(subChildMenu);
                                    } else {
                                        if (childMenu.hasOwnProperty('isOperation') && child.isOperation) {
                                            childMenu.isShow = true;
                                        }
                                        menuData.push(childMenu);
                                    }
                                } else {
                                    if (parentMap.has(child.pId)) {
                                        let subChildMenu = cloneDeep(child);
                                        subChildMenu.isShow = true;
                                        parentMap.get(child.pId).children.push(subChildMenu);
                                    } else {
                                        menuData.push(childMenu);
                                    }
                                }
                            }
                            if (menu.path === (ROUTER_BASE_PATH + target) || target === '/office') {
                                if (childMenu.hasOwnProperty('isOffice') && child.isOffice) {
                                    childMenu.isShow = childMenu.isNewMenu;
                                    menuData.push(childMenu);
                                }
                            }
                        });
                    }
                });
                if (target === '/application' && designMenus && designMenus.length > 0) {
                    menuData = designMenus.sort(this.compareArr('sortOrder'));
                }
                return menuData;
            },
            compareArr (property) {
                return function (a, b) {
                    var value1 = a[property];
                    var value2 = b[property];
                    return value1 - value2;
                };
            },
            isShowLeftFunc () {
                this.handleToggleSideBar();
            },
            sortMenu () {
                this.loadTimer = new Date().getTime() + '10';
                this.isShowMenu = true;
                this.menuData = cloneDeep(this.workPlantEntry);
                setTimeout(() => {
                    if (this.$refs.sidebar) {
                        this.$refs.sidebar.refMenu(this.menuData, this.menuData[0].id, this.menuData[0].name);
                    }
                }, 0);
            }
        }
    };
</script>

<style lang="less">
    .app-wrapper {
        .main-container {
            display: flex;
            flex-direction: column;
        }

        .app-container {
            flex: 1;
            display: flex;
            min-width: 1024px;
            overflow-x: auto;
        }
    }
</style>



// WEBPACK FOOTER //
// src/pages/Layout/Layout.vue